import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('PublicationDownloadLogicService.js');

import AppModeEnum from '@/enums/AppModeEnum';
import PublicationsTypesEnum from '@shared/enums/PublicationsTypesEnum';

import PublicationNavigateLogicService from '@/services/PublicationLogic/PublicationNavigateLogicService';
import { downloadBookById } from '@/services/utils/BookDownloader';

async function downloadAutoupdate(store, router) {
  try {
    const isAllowedUpdateAssets = _isAllowedUpdateAssets(store);
    if (!isAllowedUpdateAssets) {
      return;
    }

    const publicationId = store.getters['OpenParameterStore/getPublicationId'];
    const publicationType =
      store.getters['OpenParameterStore/getPublicationType'];
    if (!publicationId || !publicationType) {
      return;
    }
    await store.dispatch('PublicationStore/initBookAssets', {
      bookId: publicationId,
      forced: true
    });

    if (publicationType !== PublicationsTypesEnum.COMPILATION) {
      await _autoUpdatePublication(store, router);
      await downloadBookById(publicationId, store);
    }
  } catch (error) {
    logger.error(
      `Get error on downloadBookById on present publication mounted error:${error}`
    );
  }
}

async function _autoUpdatePublication(store, router) {
  const isAllowedUpdateAssets = _isAllowedUpdateAssets(store);
  const publicationId = store.getters['OpenParameterStore/getPublicationId'];

  if (!isAllowedUpdateAssets || !publicationId) {
    return;
  }
  const updateResponse = await store.dispatch(
    'PublicationStore/autoUpdateBook',
    publicationId
  );
  if (updateResponse.isUpdated()) {
    await store.dispatch('PublicationStore/initPublicationContent', {
      publicationId
    });
    const paragraphId = store.getters['OpenParameterStore/getParaId'];
    PublicationNavigateLogicService.openPublication(store, router, {
      openSamePara: true,
      paragraphId,
      openOffset: 0
    });
  }
}

function _isAllowedUpdateAssets(store) {
  const appMode = store.getters['ContextStore/appModeGetter'];
  const isReader = appMode === AppModeEnum.READER;
  const isOnline = store.getters['ContextStore/isOnline'];
  return isReader && isOnline;
}

export default {
  downloadAutoupdate
};
